import { Enums } from 'helpers/dropdown-enums';
import { getEnumTextByValue } from 'helpers/generic.methods';
import storage from 'helpers/storage';
import store from 'store';

const Chatroom = function (data) {
  let me = this;
  me.data = data;
  const {
    auth: { profile }
  } = store.getState();
  const isUserActive = profile?.Active;
  // const isUserActive = JSON.parse(
  //   storage.getItem('messagingDashboard_isActive')
  // );
  const _currentUserId = profile ? profile.UserID : 0; // get from localStorage profile
  const _currentUserStatus = isUserActive !== undefined ? isUserActive : true; // save/get from localStorage dashboard Active/inActive
  const _checkCurrentUserIsParticipant = () => {
    if (me.data.participants) {
      for (var j = 0; j < me.data.participants.length; j++) {
        if (me.data.participants[j].userId == _currentUserId) {
          return true;
        }
      }
    }
    return false;
  };

  const _isParticipant = !!_checkCurrentUserIsParticipant();
  const _currentUserIsParticipant = () => {
    return _isParticipant;
  };
  const _isAssignedTo = userId => {
    userId = _currentUserId;
    return (
      ((me.data.assignedToAgent == userId ||
        me.data.assignedToOperator == userId) &&
        me.data.currentlyAssignedTo === 0 &&
        !me.data.generallyAvailable &&
        !me.data.transferredTo) ||
      me.data.transferredTo == userId ||
      (_isParticipant && !me.data.transferredTo) ||
      me.data.requestTransferTo == userId ||
      (me.data.requestTransferIds &&
        me.data.requestTransferIds.includes(userId)) ||
      me.data.currentlyAssignedTo == userId
    );
  };
  const _isAssignedToCurrentUser = () => {
    return _isAssignedTo(_currentUserId);
  };
  const _isCurrentlyAssignedTo = () => {
    return (
      me.data.currentlyAssignedTo == _currentUserId &&
      !!_checkCurrentUserIsParticipant()
    );
  };
  const _shouldAutoPick = () => {
    // user must not be active
    if (_currentUserStatus != 'active') {
      return false;
    }
    // TODO: ApexChat.Dashboard.AutoPickup.isEnabled() Need to implement
    // should auto pick if autopick is enabled, or the chat is transferred to user from agent (through chat transfer request)
    return (
      /*ApexChat.Dashboard.AutoPickup.isEnabled() &&*/ _isAssignedToCurrentUser() ||
      (me.data.transferType === Enums.TransferChatType.AgentToOperatorWeb &&
        me.data.transferredTo == _currentUserId)
    );
  };
  const _isGenerallyAvailable = () => {
    return me.data.generallyAvailable;
  };
  const _isGenerallyAvailableToOperators = () => {
    return me.data.generallyAvailableToOperators;
  };
  const _isActive = () => {
    return me.data.status == Enums.ChatStatus.Active;
  };
  const _isInactive = () => {
    return me.data.status == Enums.ChatStatus.Inactive;
  };
  const _isAwaitingPickup = () => {
    return me.data.status == Enums.ChatStatus.AwaitingPickup;
  };
  const _isShelved = () => {
    return me.data.status == Enums.ChatStatus.Shelved;
  };
  const _isAvailable = () => {
    return (
      me.data.status == Enums.ChatStatus.AwaitingPickup ||
      me.data.pickedUpBy == 0
    );
  };
  const _hasEverBeenPickedUp = () => {
    return me.data.pickedUpBy > 0;
  };
  const _getId = () => {
    return me.data.chatId;
  };
  const _getCompanyName = () => {
    return me.data.companyName;
  };
  const _getCompanyId = () => {
    return me.data.companyId;
  };
  const _getCompanyKey = () => {
    return me.data.companyKey;
  };
  const _getReferrer = () => {
    return me.data.referrer;
  };
  const _getLocation = () => {
    return me.data.location;
  };
  const _getData = () => {
    return me.data;
  };
  const _getCurrentUserId = () => {
    return _currentUserId;
  };
  const _getPickedUpByUsername = () => {
    return me.data.pickedUpByUsername;
  };
  const _getPriority = () => {
    return me.data.priority;
  };
  const _getLanguage = () => {
    return me.data.threeLetterISOLanguageName;
  };
  const _getPickedUpOn = () => {
    return me.data.pickedUpOn;
  };
  const _getParticipantNames = () => {
    let names = me.data?.participants
      ?.map(participant => participant.username)
      .filter(Boolean);
    return names?.join();
  };
  const _getChatInitiatedBy = () => {
    let value = getEnumTextByValue(Enums.InitiatedBy, me.data.initiatedBy);
    return value;
  };

  const _getTransferType = () => {
    return me.data.transferType;
  };
  const _isRunByAgent = () => {
    return me.data.pickedUpBy > 0 && !me.data.pickedUpByOperator;
  };
  const _isPickedUpByOperator = () => {
    return me.data.pickedUpByOperator;
  };
  const _isRoutedToDefaultGroup = () => {
    return me.data.routedToDefaultGroup;
  };
  const _isSMSTransferred = () => {
    return me.data.transferType === Enums.TransferChatType.AgentToOperatorSMS;
  };
  const _isWebTransferred = () => {
    return me.data.transferType === Enums.TransferChatType.AgentToOperatorWeb;
  };
  return {
    data: me.data,
    isParticipant: _isParticipant,
    currentUserIsParticipant: _currentUserIsParticipant,
    isAssignedTo: _isAssignedTo,
    isAssignedToCurrentUser: _isAssignedToCurrentUser,
    isCurrentlyAssignedTo: _isCurrentlyAssignedTo,
    shouldAutoPick: _shouldAutoPick,
    isGenerallyAvailable: _isGenerallyAvailable,
    isGenerallyAvailableToOperators: _isGenerallyAvailableToOperators,
    isActive: _isActive,
    isInactive: _isInactive,
    isAwaitingPickup: _isAwaitingPickup,
    isShelved: _isShelved,
    isAvailable: _isAvailable,
    hasEverBeenPickedUp: _hasEverBeenPickedUp,
    getId: _getId,
    getCompanyName: _getCompanyName,
    getCompanyId: _getCompanyId,
    getCompanyKey: _getCompanyKey,
    getReferrer: _getReferrer,
    getLocation: _getLocation,
    getData: _getData,
    getPriority: _getPriority,
    getLanguage: _getLanguage,
    getCurrentUserId: _getCurrentUserId,
    getPickedUpOn: _getPickedUpOn,
    getPickedUpByUsername: _getPickedUpByUsername,
    getParticipantNames: _getParticipantNames,
    getChatInitiatedBy: _getChatInitiatedBy,
    getTransferType: _getTransferType,
    isRunByAgent: _isRunByAgent,
    isPickedUpByOperator: _isPickedUpByOperator,
    isRoutedToDefaultGroup: _isRoutedToDefaultGroup,
    isSMSTransferred: _isSMSTransferred,
    isWebTransferred: _isWebTransferred
  };
};
export default Chatroom;

export const getRealTimeCommunicationChannels = chatId => {
  var channels = [
    '/chatroom/' + chatId,
    '/chatroom/' + chatId + '/typing',
    '/chatroom/' + chatId + '/participants',
    '/chatroom/' + chatId + '/meta',
    // '/calls/chat/' + chatId,   // we are separatly creating a listner on demand listner_call_connect_status_by_id
    '/chatroom/' + chatId + '/virtualassistant/ner',
    '/chatroom/' + chatId + '/templatedquestions/answer',
    '/chatroom/' + chatId + '/live',
    '/chatroom/' + chatId + '/realtime/text',
    '/chatroom/' + chatId + '/scriptsuggestion'
  ];
  return channels;
};

export const chatChanged = (data, suppressEvents) => {
  let chatroomByType = {
    includeInSections: [],
    excludeInSections: [],
    room: null
  };
  // wrap up the incoming data to get us some helper methods
  var room = new Chatroom(data);

  console.log('chatchanged:: data', room.getId());
  const user = JSON.parse(storage.getItem('Profile'));
  const _currentUserId = user ? user.UserID : 0; // get from localStorage profile
  const {
    roles: { roles },
    auth: { profile }
  } = store.getState();
  const messagingDashboard_isActive = profile?.Active;

  // update the appropriate queue with any changes
  if (room.isActive()) {
    if (room.isAssignedToCurrentUser()) {
      if (
        roles.isOperator &&
        (!room.isPickedUpByOperator() || !room.isCurrentlyAssignedTo())
      ) {
        // do nothing
      } else {
        // chatroomByType.type = Enums.RoomType.ActiveChat;
        if (
          !chatroomByType.includeInSections.includes(Enums.RoomType.ActiveChat)
        ) {
          chatroomByType.includeInSections.push(Enums.RoomType.ActiveChat);
        }
        // dispatch::ADD::room to myActiveChats
      }
    }
    // chatroomByType.type = Enums.RoomType.AllChat;
    if (!chatroomByType.includeInSections.includes(Enums.RoomType.AllChat)) {
      chatroomByType.includeInSections.push(Enums.RoomType.AllChat);
    }
    // dispatch::ADD::room to allActiveChats
  } else if (room.isAvailable()) {
    if (room.isAssignedToCurrentUser()) {
      // chatroomByType.type = Enums.RoomType.IncomingChat;
      if (
        !chatroomByType.includeInSections.includes(Enums.RoomType.IncomingChat)
      ) {
        chatroomByType.includeInSections.push(Enums.RoomType.IncomingChat);
      }
      // dispatch::ADD::room to incomingChats
    } else if (room.isGenerallyAvailable()) {
      if (
        messagingDashboard_isActive ||
        roles.isOpsManager ||
        roles.isIsrTrainer
      ) {
        if (room.isRoutedToDefaultGroup()) {
          if (roles.isUserAssignedToDefaultGroup) {
            // chatroomByType.type = Enums.RoomType.IncomingChat;
            if (
              !chatroomByType.includeInSections.includes(
                Enums.RoomType.IncomingChat
              )
            ) {
              chatroomByType.includeInSections.push(
                Enums.RoomType.IncomingChat
              );
            }
            // dispatch::ADD::room to incomingChats
          }
        } else {
          // chatroomByType.type = Enums.RoomType.IncomingChat;
          if (
            !chatroomByType.includeInSections.includes(
              Enums.RoomType.IncomingChat
            )
          ) {
            chatroomByType.includeInSections.push(Enums.RoomType.IncomingChat);
          }
          // dispatch::ADD::room to incomingChats
        }
      }
    } else if (room.isGenerallyAvailableToOperators() && roles.isOperator) {
      if (messagingDashboard_isActive) {
        // chatroomByType.type = Enums.RoomType.IncomingChat;
        if (
          !chatroomByType.includeInSections.includes(
            Enums.RoomType.IncomingChat
          )
        ) {
          chatroomByType.includeInSections.push(Enums.RoomType.IncomingChat);
        }
        // dispatch::ADD::room to incomingChats
      }
    }

    // TODO: In future, when we will implement Shelved chat, we will remove this room for shelvedChat section
    if (
      !chatroomByType.excludeInSections.includes(Enums.RoomType.ShelvedChat)
    ) {
      chatroomByType.excludeInSections.push(Enums.RoomType.ShelvedChat);
    }
    // Ext.getCmp('shelvedChats').removeChatRecord(room);
  } else if (room.isShelved() && room.isAssignedToCurrentUser()) {
    // dispatch room to allActiveChats
    // TODO: In future, dispatch::ADD::room to shelvedChats
    if (
      !chatroomByType.includeInSections.includes(Enums.RoomType.ShelvedChat)
    ) {
      chatroomByType.includeInSections.push(Enums.RoomType.ShelvedChat);
    }
    // Ext.getCmp('shelvedChats').upsertChatRecord(room);
  }

  // remove records from the appropriate queues
  if (!room.isAssignedToCurrentUser()) {
    var remove = false;
    if (roles.isAgent && !room.isGenerallyAvailable()) {
      remove = true;
    }
    if (
      roles.isOperator &&
      !room.isGenerallyAvailableToOperators() &&
      !room.isSMSTransferred()
    ) {
      remove = true;
    }

    if (remove) {
      if (
        !chatroomByType.excludeInSections.includes(Enums.RoomType.IncomingChat)
      ) {
        chatroomByType.excludeInSections.push(Enums.RoomType.IncomingChat);
      }
      //dispatch::REMOVE::room to incomingChats
    }
  }

  //Donot remove chat from incoming grid if it is transferred chat
  if (
    !room.isAvailable() &&
    room.data?.transferType !== Enums.TransferChatType.AgentToOperatorWeb
  ) {
    // not available = remove from incoming, always
    if (
      !chatroomByType.excludeInSections.includes(Enums.RoomType.IncomingChat)
    ) {
      chatroomByType.excludeInSections.push(Enums.RoomType.IncomingChat);
    }
    //dispatch::REMOVE::room to incomingChats
  }

  if (
    !room.isAssignedToCurrentUser() ||
    (roles.isOperator && !room.isPickedUpByOperator()) ||
    (roles.isAgent && room.isPickedUpByOperator()) ||
    (roles.isOperator && room.data.currentlyAssignedTo != _currentUserId)
  ) {
    // the only time when a room will not  have participants is when its a message update....
    if (room.data.participants) {
      if (
        !chatroomByType.excludeInSections.includes(Enums.RoomType.ActiveChat)
      ) {
        chatroomByType.excludeInSections.push(Enums.RoomType.ActiveChat);
      }
      //dispatch::REMOVE::room to myActiveChats
    }
  }

  if (
    roles.isAgent &&
    room.data.transferType === Enums.TransferChatType.AgentToOperatorSMS
  ) {
    if (
      !chatroomByType.excludeInSections.includes(Enums.RoomType.IncomingChat)
    ) {
      chatroomByType.excludeInSections.push(Enums.RoomType.IncomingChat);
    }
    //dispatch::REMOVE::room to incomingChats
  }

  if (!room.isActive()) {
    if (!chatroomByType.excludeInSections.includes(Enums.RoomType.ActiveChat)) {
      chatroomByType.excludeInSections.push(Enums.RoomType.ActiveChat);
    }
    //dispatch::REMOVE::room to myActiveChats
    if (!room.isShelved()) {
      if (!chatroomByType.excludeInSections.includes(Enums.RoomType.AllChat)) {
        chatroomByType.excludeInSections.push(Enums.RoomType.AllChat);
      }
      //dispatch::REMOVE::room to allActiveChats
    }
  }
  chatroomByType.room = room;

  // if in exclude remove from include
  if (chatroomByType.excludeInSections.length) {
    chatroomByType.includeInSections = chatroomByType.includeInSections.filter(
      item => !chatroomByType.excludeInSections.includes(item)
    );
  }

  return chatroomByType;
  // TODO: suppressEvents work is remaining..
};
